module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-52875a88.svg";